import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router-dom';
import { useListContext, useUnselectAll } from 'ra-core';
import { notification } from 'antd';
import Button from '@mui/material/Button';
import { useRefresh, useResourceContext } from 'react-admin';

import { http } from '@network';
import { useSettingsContext } from '@providers';
import { Sidepanel } from '@components/Sidepanel';
import { InitialRow } from '@components/InitialCard';

export const ConfirmRestore = () => {
  const location = useLocation();
  const { setPanelName } = useSettingsContext();
  const resource = useResourceContext();
  const sidepanelName = 'ConfirmRestore';

  useEffect(() => void setPanelName(null), [location.pathname]);

  const showRestorePanel = ['user-deleted', 'credit-deleted'].includes(resource);

  return (
    <Sidepanel name={sidepanelName}>
      {showRestorePanel && <Restore resource={resource} />}
    </Sidepanel>
  );
};

const Restore = ({ resource }: {resource: string}) => {
  const refresh = useRefresh();
  const unselect = useUnselectAll(resource);
  const { selectedIds } = useListContext();
  const { setPanelName } = useSettingsContext();
  const cls = useStyles();

  const ids = selectedIds ?? [];
  const hidePanel = () => setPanelName(null);

  const restoreMany = async () => {
    if (ids.length === 0) {
      return notification.error({ message: 'You should select records', duration: 8 });
    }

    await Promise.all(ids.map(
      id => http.post(`${resource}/${id}/restore`),
    ));

    notification.success({
      message: `The selected records (${ids.length}) have been restored successfully`,
      duration: 8,
    });
    hidePanel();
    refresh();
    unselect();
  };

  const resourceFirst = resource.split('-')[0];
  const title = `${resourceFirst.charAt(0).toUpperCase() + resourceFirst.slice(1)}s`;
  const subtitle = `${ids.length} ${title}`;

  return (
    <div className={cls.removal}>
      <div className={cls.removalTitle}>Restore records</div>
      <InitialRow title={title}>
        {subtitle}
      </InitialRow>
      <div className={cls.removalActions}>
        <Button
          className={cls.btn}
          color="error"
          type="button"
          variant="outlined"
          onClick={hidePanel}
        >Cancel</Button>
        <Button
          className={cls.btn}
          color="secondary"
          type="button"
          variant="contained"
          onClick={restoreMany}
        >Restore</Button>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  removal: {
    width: 350,
    margin: '100px auto 0',
    color: '#000',
  },
  removalActions: {
    marginTop: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  btn: {
    width: '48%',
    textTransform: 'none',
    borderRadius: 8,
    borderWidth: '2px',
    '&:hover': {
      borderWidth: '2px',
    },
  },
  removalTitle: {
    fontSize: 28,
    display: 'flex',
    justifyContent: 'center',
  },
  textarea: {
    borderRadius: 8,
    border: '2px solid #002A77',
    height: '100px !important',
    padding: '8px 12px',
    backgroundColor: '#E1E5ED',
    fontSize: 12,
    lineHeight: 1.1,

    '> div::before': {
      display: 'none',
    },

    '&::placeholder': {
      color: '#74706B',
      fontSize: 12,
      lineHeight: 1.1,
    },
  },
});
